import React from 'react';
import { Presentation, Users, ClipboardCheck, Bot, Compass, Handshake, ArrowRight } from 'lucide-react';
import { programOptions } from '../data/mock';
import { Button } from './ui/button';
import { trackCTAClick } from '../utils/analytics';

const iconMap = {
  Presentation: Presentation,
  Users: Users,
  ClipboardCheck: ClipboardCheck,
  Bot: Bot,
  Compass: Compass,
  Handshake: Handshake
};

const Services = () => {
  const scrollToConsultation = () => {
    trackCTAClick('Schedule a Leadership Strategy Session', 'services');
    const element = document.querySelector('#consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-16 sm:py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Engagement Options
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            Flexible Ways to
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-400">
              Work With Us
            </span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto">
            Choose the format that fits your needs—from single workshops to ongoing partnerships. 
            Every engagement is customized to your organization's goals.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12">
          {programOptions.map((option) => {
            const IconComponent = iconMap[option.icon];
            return (
              <div
                key={option.id}
                className="group p-6 rounded-2xl bg-slate-950/50 border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center mb-4 group-hover:bg-cyan-500/20 transition-colors">
                  <IconComponent className="h-6 w-6 text-cyan-400" />
                </div>

                {/* Title */}
                <h3 className="text-white font-bold text-lg mb-2 group-hover:text-cyan-400 transition-colors">
                  {option.title}
                </h3>

                {/* Description */}
                <p className="text-slate-400 text-sm leading-relaxed">
                  {option.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={scrollToConsultation}
            data-testid="services-cta-button"
            variant="outline"
            className="border-slate-700 text-white hover:bg-white/5 px-8 py-6 text-lg"
          >
            Schedule a Leadership Strategy Session
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <p className="text-slate-500 text-sm mt-4">
            Eligible organizations may qualify for workforce training funding or reimbursement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
